import { VolumeUpIcon } from '@heroicons/react/outline';

export function AudioFileIcon() {
  return <VolumeUpIcon className="h-full text-file-audio-enabled" />;
}
